import { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'
import Link from 'next/link'
import DownloadButton from '../buttons/download-button'

interface LinkElementProps extends PropsWithChildren {
  className?: string
  isButton?: boolean
  url: string
}

const LinkElement = ({
  className,
  children,
  isButton,
  url,
}: LinkElementProps) => {
  const formatUrl = url.replace('button:', '')

  return isButton ? (
    <span className={cn('flex w-full items-center justify-center', className)}>
      <DownloadButton url={formatUrl}>{children}</DownloadButton>
    </span>
  ) : (
    <Link href={url}>{children}</Link>
  )
}

export default LinkElement
